<template>
    <div>
        <inertia-link :href="route('dashboard')" :class="classes('dashboard')">
            Dashboard
        </inertia-link>
      <div v-if="$can('manage-users')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Management</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('users')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out" :class="classes('users')">
              Manage users
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('shops')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out" :class="classes('shops')">
              Manage shops
            </inertia-link>
          </li>
        </ul>
      </div>

      <!--     START SUPERVISOR     -->
      <inertia-link v-if="$can('affectation')" :href="route('supervisor.affectedList')" :class="classes('supervisor.affectedList')">
        Reception de poste
      </inertia-link>
      <inertia-link v-if="$can('affectation')" :href="route('supervisor.list')" :class="classes('supervisor.list')">
        Affectation de poste
      </inertia-link>
      <inertia-link v-if="$can('affectation')" :href="route('supervisor.techReceived')" :class="classes('supervisor.techReceived')">
        Accusée de reception
      </inertia-link>
<!--      <div class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Visualisation</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('stock.create')" class="block w-full border-none py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out" :class="classes('stock.create')">
              Tableau de bord
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('stock.list')" class="block w-full border-none py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"  :class="classes('stock.list')">
              recherche
            </inertia-link>
          </li>
        </ul>
      </div>-->
      <!--     END SUPERVISOR     -->

      <!--      START TECH      -->
      <div v-if="$can('reparation')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Reception de poste</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('tech.svList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out" :class="classes('tech.svList')">
              Reception Superviseur
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('tech.qtList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"  :class="classes('tech.qtList')">
              Reception Devis
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('tech.testReturnList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"  :class="classes('tech.qtList')">
              Reception Test
            </inertia-link>
          </li>
        </ul>
      </div>

      <inertia-link v-if="$can('reparation')" :href="route('tech.list')" :class="classes('tech.list')">
        Liste postes
      </inertia-link>

      <div v-if="$can('reparation')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Accusé De Reception</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('tech.testReceived')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out" :class="classes('tech.svList')">
              Accusé Test
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('tech.quoteReceived')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"  :class="classes('tech.qtList')">
              Accusé Devis
            </inertia-link>
          </li>
        </ul>
      </div>
    <!--      END TECH      -->

      <!--      START STOCK      -->
      <div v-if="$can('manage-stock')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Stock</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('stock.create')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100" :class="classes('stock.create')">
              Nouveau Stock
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('stock.list')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"  :class="classes('stock.list')">
              List Stock
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('stock.receiveList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"  :class="classes('stock.receiveList')">
              Reception Stock
            </inertia-link>
          </li>
        </ul>
      </div>

      <div v-if="$can('defect-siege')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Defect</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('defect.receiveList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                          :class="classes('defect.receiveList')">
              List Defect
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('defect.returnList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                          :class="classes('defect.returnList')">
              Retour Defect
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('defect.returnedList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                          :class="classes('defect.returnedList')">
              Defect retourné
            </inertia-link>
          </li>
        </ul>
      </div>

      <inertia-link v-if="$can('repair-price')" :href="route('repairPrice.index')" :class="classes('repairPrice.index')">
        Prix reparations
      </inertia-link>

      <div v-if="$can('stock')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Stock</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link v-if="$can('stock')" :href="route('stock.listStock')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"  :class="classes('stock.listStock')">
              List-Stock
            </inertia-link>
          </li>
          <li>
            <inertia-link v-if="$can('stock') || $can('manage-stock')" :href="route('stock.receiveList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"  :class="classes('stock.receiveList')">
              Reception Stock
            </inertia-link>
          </li>
        </ul>
      </div>

      <div v-if="$can('defect-shop')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Defect</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('defect.sendList')" class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                          :class="classes('defect.sendList')">
              Envoi Defect
            </inertia-link>
          </li>
        </ul>
      </div>

      <inertia-link v-if="$can('orders')" :href="route('stock.orders')"  :class="classes('stock.orders')">
        Commandes
      </inertia-link>

      <inertia-link v-if="$can('orders')" :href="route('stock.ordersList')"  :class="classes('stock.ordersList')">
        Commandes confirmer
      </inertia-link>
      <!--      END STOCK      -->

      <!--      start Devis      -->
      <inertia-link v-if="$can('quote')" :href="route('quote.receiveList')"  :class="classes('quote.receiveList')">
        Reception Devis
      </inertia-link>
      <inertia-link v-if="$can('quote')" :href="route('quote.list')"  :class="classes('quote.list')">
        Liste postes Devis
      </inertia-link>
      <inertia-link v-if="$can('quote')" :href="route('quote.status')"  :class="classes('quote.status')">
        Etat Poste Devis
      </inertia-link>
      <inertia-link v-if="$can('finance-management')" :href="route('quote.sales')"  :class="classes('quote.sales')">
        Ventes
      </inertia-link>
      <inertia-link v-if="$can('quote')" :href="route('quote.export')" :class="classes('quote.export')">
        Exportation Devis
      </inertia-link>
      <!--      END Devis      -->

      <!--      start TEST      -->
      <div v-if="$can('test')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Technicien</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-48 origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('test.receiveList')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 " :class="classes('test.receiveList')">
              Reception technicien
            </inertia-link>
            <inertia-link :href="route('test.repairedTestList')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 " :class="classes('test.repairedTestList')">
              Liste de Poste Test
            </inertia-link>
            <inertia-link :href="route('test.irreparableTestList')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 " :class="classes('test.irreparableTestList')">
              Liste de Poste irreparable
            </inertia-link>
          </li>
        </ul>
      </div>
      <div v-if="$can('test')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1 w-max">Devis refusé</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('test.receiveRejectedQuoteList')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 " :class="classes('test.receiveRejectedQuoteList')">
              Reception Devis refusé
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('test.rejectedQuoteList')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 " :class="classes('test.rejectedQuoteList')">
              Liste de Poste Refusé
            </inertia-link>
          </li>
        </ul>
      </div>

      <inertia-link v-if="$can('test')" :href="route('test.expedition')"  :class="classes('test.expedition')">
        Expedition
      </inertia-link>

      <inertia-link v-if="$can('test')" :href="route('test.sent')"  :class="classes('test.sent')">
        Postes expedié
      </inertia-link>
      <!--      END TEST      -->

      <!--      START LOGISTIC     -->
      <div v-if="$can('reception')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Reception de poste</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('receptions.create')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 " :class="classes('receptions.create')">
              Nouveau Poste
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('receptions.list')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 "  :class="classes('receptions.list')">
              List des Postes
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('receptions.sent')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 "  :class="classes('receptions.sent')">
              Accusé de Reception Superviseur
            </inertia-link>
          </li>
        </ul>
      </div>
      <div v-if="$can('shipment')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Envoi</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('shipment.receiveList')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 " :class="classes('shipment.receiveList')">
              Reception de poste
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('shipment.list')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 "  :class="classes('shipment.list')">
              Poste Prés à l'Envoi
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('shipment.shipped')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 "  :class="classes('shipment.shipped')">
              Poste Envoyer
            </inertia-link>
          </li>
        </ul>
      </div>
      <div v-if="$can('manage-agents')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
            <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
                <span class="mr-1">Gestion</span>
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
            </button>
        <ul :class="tmpClasses()"
          class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('agents')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                          :class="classes('agents')">
              Agents
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('malfunctions')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                          :class="classes('malfunctions')">
              Pannes
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('brands')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                          :class="classes('brands')">
              Marques
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('models')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 top-45px"
                          :class="classes('models')">
              Modeles
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('operators')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                          :class="classes('operators')">
              Opérateurs
            </inertia-link>
          </li>
          <li>
            <inertia-link :href="route('agencies')" class="block w-full border-none px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                          :class="classes('agencies')">
              Agences
            </inertia-link>
          </li>
        </ul>
      </div>
      <div v-if="$can('returns')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Retour</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('return.list')" :class="classes('return.list')"
                          class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
              Visualisation Des Retours
            </inertia-link>
          </li>
        </ul>
      </div>
      <inertia-link v-if="$can('sales')" :href="route('sales.list')" :class="classes('sales.list')">
        Ventes
      </inertia-link>

      <inertia-link v-if="$can('swap')" :href="route('swap.list')" :class="classes('swap.list')">
        SWAP
      </inertia-link>

      <div v-if="$can('visualisation')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Visualisation</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('dashboard.repairSearch')" :class="classes('dashboard.repairSearch')"
                          class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
              Recherche
            </inertia-link>
            <inertia-link :href="route('dashboard.repairsExtract')" :class="classes('dashboard.repairsExtract')"
                          class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
              Exportation des Reparations
            </inertia-link>
          </li>
        </ul>
      </div>

      <div v-if="$can('stock-reports')" class="group flex sm:inline-flex relative items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out">
        <button class="bg-white border-transparent text-sm font-medium leading-5 transition duration-150 ease-in-out text-gray-500 hover:text-gray-700 hover:border-gray-300 py-2 rounded inline-flex items-center">
          <span class="mr-1">Exportation</span>
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
        </button>
        <ul :class="tmpClasses()" class="group-hover:block absolute bg-white rounded-md shadow-lg w-max origin-top-left left-0 border border-gray-100 hidden text-gray-700 pt-1 z-50">
          <li>
            <inertia-link :href="route('stock.stockExtract')" :class="classes('stock.stockExtract')"
                          class="block w-full border-none px-4 py-2 leading-5 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
              Exportation de stock
            </inertia-link>
          </li>
        </ul>
      </div>
    </div>
    <!--      END LOGISTIC     -->
</template>

<script>
    export default {
        props: ['href', 'active'],

        computed: {

        },
        methods: {
            classes(pageName) {
                return pageName === route().current()
                            ? 'flex items-center border-b-2 border-indigo-400 text-sm font-medium leading-5 text-gray-900 focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out'
                            : 'flex items-center border-b-2 border-transparent text-sm font-medium leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 transition duration-150 ease-in-out'
            },
            tmpClasses() {
             return (this.$page.props.user.role_name === 'super-admin' || this.$page.props.user.role_name === 'admin' || this.$page.props.user.role_name === 'supervisor')
                      ? 'top-8'
                      : 'top-15'
            }
        }
    }
</script>
